import enAccount from "../account/locales/en";
import enBalanceSheet from "../balance-sheet/locales/en";
import enCashFlow from "../cash-flow/locales/en";
import enIncomeStatement from "../income-statement/locales/en";
import enTrialBalance from "../trial-balance/locales/en";
import enOverview from "../overview/locales/en";
import enExport from "../export/locales/en";

const enReportsShared = {
  "page.reports.hierarchyTitle": {
    message: "{sectionName} Hierarchy",
    description:
      "Title for hierarchy visualization card with dynamic section name",
  },
  "page.reports.hierarchyListTitle": {
    message: "{sectionName} List",
    description: "Title for hierarchy list card with dynamic section name",
  },
  "page.reports.hierarchyVisualizationDescription": {
    message: "Visual representation of {ledgerName} {sectionName} composition",
    description:
      "Description for hierarchy visualization with dynamic section name",
  },
  "page.reports.hierarchyListDescription": {
    message:
      "Detailed breakdown of {ledgerName} {sectionName} by account and commodity",
    description: "Description for hierarchy list with dynamic section name",
  },
  "page.reports.incomeVsExpenses": {
    message: "Income vs Expenses",
    description: "Title for income vs expenses chart",
  },
  "page.reports.incomeVsExpensesDescription": {
    message:
      "Bar chart comparing total income and expenses for each interval in the selected period.",
    description: "Description for income vs expenses chart",
  },
};

const enReports = {
  ...enReportsShared,
  ...enAccount,
  ...enBalanceSheet,
  ...enCashFlow,
  ...enIncomeStatement,
  ...enTrialBalance,
  ...enOverview,
  ...enExport,
  "page.overview.starButton.starSuccess": {
    message: "Ledger starred successfully",
    description: "Toast shown after starring a ledger",
  },
  "page.overview.starButton.starFailed": {
    message: "Failed to star ledger",
    description: "Toast shown when starring a ledger fails",
  },
  "page.overview.starButton.unstarSuccess": {
    message: "Ledger unstarred successfully",
    description: "Toast shown after unstarring a ledger",
  },
  "page.overview.starButton.unstarFailed": {
    message: "Failed to unstar ledger",
    description: "Toast shown when unstarring a ledger fails",
  },
};

export default enReports;
